import React, { useEffect, useState } from "react";

const API_BASE_URL = "";

const FAQSection = ({ pageKey, title, faqData }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [sectionTitle, setSectionTitle] = useState(title || "");
  const [items, setItems] = useState(faqData || []);

  useEffect(() => {
    if (!pageKey) {
      setSectionTitle(title || "");
      setItems(faqData || []);
      return;
    }

    const fetchFaqs = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/faqs/${encodeURIComponent(pageKey)}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch FAQs");
        }

        const data = await response.json();

        if (data.title) {
          setSectionTitle(data.title);
        }

        if (Array.isArray(data.items) && data.items.length > 0) {
          setItems(data.items);
        }
      } catch (error) {
        console.error("FAQ fetch error:", error);
      }
    };

    fetchFaqs();
  }, [pageKey]);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <>
      <section className="ib-faq-section">
        <div className="ib-faq-container">
          <header className="ib-faq-header">
            <span className="ib-faq-label">Common Questions</span>
            <h2 className="ib-faq-title">{sectionTitle}</h2>
          </header>

          <div className="ib-faq-list">
            {items.map((item, index) => (
              <div
                key={index}
                className={`ib-faq-item ${activeIndex === index ? "is-active" : ""}`}
              >
                <button
                  className="ib-faq-question-btn"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={activeIndex === index}
                >
                  <span className="ib-faq-question-text">{item.question}</span>
                  <div className="ib-faq-icon">
                    <div className="ib-icon-line ib-line-h"></div>
                    <div className="ib-icon-line ib-line-v"></div>
                  </div>
                </button>
                <div className="ib-faq-answer-wrapper">
                  <div className="ib-faq-answer-content">{item.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQSection;
